<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  error: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'text',
  },
  id: {
    type: String,
    default: null,
  },
})

const emit = defineEmits(['update:modelValue'])
</script>

<template>
  <div class="group" :class="{ error }">
    <template v-if="type === 'select'">
      <select
          :id="id"
          :value="props.modelValue"
          @input="emit('update:modelValue', $event.target.value)"
          class="select"
          v-bind="$attrs"
          :aria-label="label"
      >
        <slot />
      </select>
    </template>
    <template v-else>
      <input
          :id="id"
          :value="props.modelValue"
          @input="emit('update:modelValue', $event.target.value)"
          class="input"
          placeholder=""
          :type="type"
          v-bind="$attrs"
          :aria-label="label"
      />
    </template>
    <label
        :for="id"
        :class="props.modelValue?.length ? 'shrink' : ''"
        class="form-input-label"
    >{{ label }}</label>
  </div>
</template>

<style lang="scss" scoped>
@mixin shrinkLabel {
  top: 4px;
  font-size: 12px;
}

.group {
  position: relative;
  display: flex;
  align-items: stretch;

  .input, .select {
    display: block;
    width: 100%;
    padding: 16px 16px 8px 16px;

    @media screen and (min-width: 768px) {
      padding: 20px 16px 12px 16px;
    }

    &:focus ~ .form-input-label {
      @include shrinkLabel();
    }
  }

  .select {
    -webkit-appearance: none;
  }

  .form-input-label {
    position: absolute;
    pointer-events: none;
    transition: 0.1s ease all;
    color: var(--neutral-700, #767370);
    left: 16px;
    top: 14px;
    font-size: 14px;
    line-height: 24px;

    @media screen and (min-width: 768px) {
      top: 18px;
      font-size: 16px;
      line-height: 28px;
    }

    &.shrink {
      @include shrinkLabel();
    }
  }
}

.group.error {
  .input, .select {
    border: 1px solid #ff0000;
  }
  .form-input-label {
    color: #ff0000;
  }
}
</style>
